import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { FaList, FaPencilAlt } from 'react-icons/fa';
import moment from 'moment';
import { reactLocalStorage } from 'reactjs-localstorage';
import LastDayOfMonth from 'date-fns/lastDayOfMonth';
import AddMonths from 'date-fns/addMonths';
import AddDays from 'date-fns/addDays';

import FieldMultiSelect from '../common/FieldMultiSelect';
import ApiUiController from '../../controller/ApiUiController';
import CallPopup from '../../components/call/CallPopup';
import MeetingPopup from '../../components/meeting/MeetingPopup';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import CallAPI from '../../api/CallAPI';
import MeetingAPI from '../../api/MeetingAPI';
import withRouter from '../../util/WithRouter';
import ViewController from '../../controller/ViewController';

import './Calendar.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Display from '../../util/Display';
import { Badge } from 'react-bootstrap';

class BigCalendar extends React.Component {

  constructor() {
    super();
    this.now = new Date();
    this.now.setDate(1);
    this.state = { popup: null, model: null, inApiCall: true, dateData: null };

    const models = reactLocalStorage.getObject(Const.Model);
    this.CallName = models.call.model_name;
    this.MeetingName = models.meeting.model_name;
    this.CallField = models.call.fields;
    this.MeetingField = models.meeting.fields;
    this.event = 'month';
    this.events = [];

    this.showCall = Util.isAllow(models.meeting.permission, Const.PermView);
    this.CallUpdate = Util.isAllow(models.call.permission, Const.PermUpdate);
    this.showMeeting = Util.isAllow(models.meeting.permission, Const.PermView);
    this.MeetUpdate = Util.isAllow(models.meeting.permission, Const.PermUpdate);
    this.CallRestrict = Util.isAllow(models.call.permission, Const.PermRestricAcc);
    this.MeetingRestrict = Util.isAllow(models.meeting.permission, Const.PermRestricAcc);

    this.field = models.meeting.fields.responsible_person;
    this.list = {
      filters: [
        {
          field: 'responsible_person', type: 'multiselect~user',
          condition: 'in', value: `~${reactLocalStorage.getObject(Const.LoggedInUser).user_id}~`
        },
        {
          field: 'date_time', type: 'datetime',
          condition: 'between', value: this.getValue()
        },
        { field: 'complete', type: 'complete', condition: 'in', value: '' }
      ], pagination: { currentPage: 1, pageCount: 1, perPage: 1000 }
    };
  }

  componentDidMount() {
    this.loadData();
  }

  getValue = () => {
    let date = new Date(this.now.getTime());
    date.setDate(1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const value = Util.dateToServerDateTime(date);
    date = LastDayOfMonth(date);
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    date.setMilliseconds(999);
    return value + Const.Opt + Util.dateToServerDateTime(date);
  };

  loadCalls = () => {
    const filters = ViewController.filters([...this.list.filters], [], [], this.CallRestrict);
    CallAPI.getList({ ...this.list, filters }, this.callsReceived);
  };

  loadMeetings = () => {
    const filters = ViewController.filters([...this.list.filters], [], [], this.MeetingRestrict);
    MeetingAPI.getList({ ...this.list, filters }, this.meetingReceived);
  };

  loadData = () => {
    this.events = [];
    if (this.showCall && this.showMeeting) {
      this.calls = null;
      this.meetings = null;
      this.loadCalls();
      this.loadMeetings();
      this.setState({ ...this.state, popup: null, dateData: null, inApiCall: true });
    } else if (this.showCall && !this.showMeeting) {
      this.calls = null;
      this.meetings = [];
      this.loadCalls();
      this.setState({ ...this.state, popup: null, dateData: null, inApiCall: true });
    } else if (!this.showCall && this.showMeeting) {
      this.calls = [];
      this.meetings = null;
      this.loadMeetings();
      this.setState({ ...this.state, popup: null, dateData: null, inApiCall: true });
    } else {
      this.calls = [];
      this.meetings = [];
      this.setState({ ...this.state, popup: null, dateData: null, inApiCall: false });
    }
  };
  callsReceived = res => {
    this.calls = res.data;
    if (this.meetings) {
      this.showEvents();
    }
  };
  meetingReceived = res => {
    this.meetings = res.data;
    if (this.calls) this.showEvents();
  };
  showEvents = res => {
    let from = new Date(this.now.getTime());
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    from.setMilliseconds(0);
    let to = new Date(this.now.getTime());
    to.setHours(23);
    to.setMinutes(59);
    to.setSeconds(59);
    to.setMilliseconds(999);

    const LastDay = LastDayOfMonth(this.now).getDate();
    for (let i = 1; i <= LastDay; i++) {
      from.setDate(i);
      to.setDate(i);
      const calls = [];
      for (let j = 0; j < this.calls.length; j++) {
        const value = Util.serverStringDateTimeToDate(this.calls[j].date_time);
        if (from.getTime() <= value.getTime() && value.getTime() <= to.getTime()) {
          calls.push(this.calls[j]);
        }
      }

      const meetings = [];
      for (let j = 0; j < this.meetings.length; j++) {
        const value = Util.serverStringDateTimeToDate(this.meetings[j].date_time);
        if (value && from.getTime() < value.getTime() && value.getTime() < to.getTime()) {
          meetings.push(this.meetings[j]);
        }
      }

      if (calls.length > 0) {
        const tmp = new Date(from.getTime());
        const title = `${calls.length} Calls`;
        const data = calls.sort((l, r) => {
          return Util.serverStringDateTimeToDate(l.date_time).getTime() - Util.serverStringDateTimeToDate(r.date_time).getTime();
        });
        this.events.push({
          title, start: tmp, end: tmp,
          data: { modelType: LeadConst.Call, type: this.CallName, data }
        });
      }
      if (meetings.length > 0) {
        const tmp = new Date(from.getTime());
        const title = `${meetings.length} Site Visit`;
        const data = meetings.sort((l, r) => {
          return Util.serverStringDateTimeToDate(l.date_time).getTime() - Util.serverStringDateTimeToDate(r.date_time).getTime();
        });
        this.events.push({
          title, start: tmp, end: tmp,
          data: { modelType: LeadConst.Meeting, type: this.MeetingName, data }
        });
      }
    }

    this.setState({ ...this.state, inApiCall: false });
  };

  onValueChange = (field, value) => {
    if (value) {
      this.list.filters[0].value = value;
      this.loadData();
    }
  };

  onRangeChange = (range, event) => {
    if (range && range.start && range.end && this.event === 'month' && !event) {
      range.start = AddDays(range.start, 8);
      if (this.now < range.start) this.now = AddMonths(this.now, 1);
      else this.now = AddMonths(this.now, - 1);
      this.list.filters[1].value = this.getValue();
      this.loadData();
    }
    if (event) {
      this.event = event;
    }
  };

  onSelectEvent = target => this.setState({ ...this.state, dateData: target.data });

  onPreview = data => {
    if (data.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${data.model_id}`);
    } else if (data.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${data.model_id}`);
    }
  };

  hidePopUp = () => this.setState({ ...this.state, popup: null });
  onEdit = (popup, model) => this.setState({ ...this.state, popup, model });
  reload = () => {
    this.setState({ ...this.state, popup: '', calls: null, meetings: null });
    this.loadData();
  };

  eventStyle = (event) => {
    let backgroundColor = '#3788d8';

    if(event.data.modelType === LeadConst.Call) {
      backgroundColor = '#28a745';
    }
    if(event.data.modelType === LeadConst.Meeting) {
      backgroundColor = '#ff6f00ff';
    }
    if(event.data.modelType === LeadConst.Task) {
      backgroundColor = '#17a2b8';
    }

    return {
      style: {
        backgroundColor,
        color: 'white',
        borderRadius: '5px',
        padding: '2px 5px',
        border: 'none'
      }
    };
  };
  
  render() {
    const CallPopUp = this.CallUpdate ?
      <CallPopup show={this.state.popup === LeadConst.Call} onHide={this.hidePopUp}
        call={this.state.model} reload={this.reload} />
      : null;
    const MeetingPopUp = this.MeetUpdate ?
      <MeetingPopup show={this.state.popup === LeadConst.Meeting} onHide={this.hidePopUp}
        meeting={this.state.model} contacts={[]} reload={this.reload} />
      : null;

    return (
      <div className="container-fluid pt-2 pb-5">
        {CallPopUp} {MeetingPopUp}
        <div className="row">
          <div className="col-md-3 pb-3"><h3>Calendar</h3></div>
          <div className="col-md-9 pb-3">
            <FieldMultiSelect key="responsible_person" id="responsible_person" field={this.field}
              value={this.list.filters[0].value} onValueChange={this.onValueChange} inValid={{}} />
          </div>
          <div className="col-md-6 pb-3"></div>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className={`col-md-${this.state.dateData ? 7 : 12}`}>
              <div style={{ height: 800 }}>
                <Calendar events={this.events} startAccessor="start" endAccessor="end"
                  defaultDate={this.now} defaultView="month" views={['month']} localizer={momentLocalizer(moment)}
                  onSelectEvent={this.onSelectEvent} onRangeChange={this.onRangeChange} eventPropGetter={this.eventStyle}/>
              </div>
            </div>
            {this.state.dateData &&
              <div className='col-md-5'>
                <table className='table table-bordered'>
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Date Time</th>
                      <th>Lead/ Contact</th>
                      <th>{this.CallField.responsible_person.label_name}</th>
                      <th>{this.CallField.comment.label_name}</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.dateData.data.map((data, i) =>
                      <tr key={`calendar_action_${i}`}>
                        <td>{this.state.dateData.type}</td>
                        <td>{Util.serverStringToDisplayDateTime(data.date_time)}</td>
                        <td>{Display.ModelName(data)}</td>
                        <td>{Display.FieldValue(data, "responsible_person", 
                              this.state.dateData.modelType === LeadConst.Call ? this.CallField : this.MeetingField
                          )}
                        </td>
                        <td>{data.comment?.replace(/<[^>]*>/g, "")}</td>
                        <td>
                          <Badge
                            variant="primary"
                            size='sm'
                            color='#ffffff'
                            className='m-1 p-2 cursor-pointer'
                            onClick={() => this.onPreview(data)}>
                            <FaList className="actionbtnp" color='#ffffff' /> View Details
                          </Badge>
                          <Badge
                            variant="secondary"
                            size='sm'
                            color='#ffffff'
                            className='m-1 p-2 text-white cursor-pointer'
                            onClick={() => this.onEdit(this.state.dateData.modelType, data)} >
                            <FaPencilAlt className="actionbtnp" color='#ffffff' />  Edit
                          </Badge>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            }
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(BigCalendar);